<template>
	<div class="home">
		<img :src="$i18n.locale == 'en' ? require('@/assets/img/logo-en.png') : require('@/assets/img/logo-br.png')">

		<p v-html="$t('home.text')">
			
		</p>
	</div>
</template>
<script>
export default{
	name: 'Home'
}
</script>


// WEBPACK FOOTER //
// src/pages/Home.vue